import PageHeader from "../components/layout/PageHeader";
import ComingSoon from "../components/ComingSoon";
import { TID } from "../lib/testIds";
import { useEffect, useState } from "react";
import { api, apiErrorMessage } from "../lib/api";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function N8nPage() {
  const [settings, setSettings] = useState(null);
  const [form, setForm] = useState({ n8n_base_url: "", n8n_api_key: "", n8n_webhook_url: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => { load(); }, []);
  async function load() {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
      setForm({
        n8n_base_url: data.n8n_base_url || "",
        n8n_api_key: "",
        n8n_webhook_url: data.n8n_webhook_url || "",
      });
    } catch (e) { toast.error(apiErrorMessage(e)); }
  }

  async function save(e) {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = {
        n8n_base_url: form.n8n_base_url,
        n8n_api_key: form.n8n_api_key,
        n8n_webhook_url: form.n8n_webhook_url,
        krai_api_base_url: settings?.krai_api_base_url || "",
        krai_api_token: "",
      };
      const { data } = await api.put("/settings", payload);
      setSettings(data);
      setForm((f) => ({ ...f, n8n_api_key: "" }));
      toast.success("Configuración n8n guardada");
    } catch (e) { toast.error(apiErrorMessage(e)); }
    finally { setSaving(false); }
  }

  return (
    <div data-testid={TID.n8n.root}>
      <PageHeader
        eyebrow="Automatización"
        title="n8n"
        description="Prepara los parámetros para tu instancia de n8n en Hostinger. Aún no realizamos llamadas reales."
      />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <form
          onSubmit={save}
          className="lg:col-span-2 rounded-md border border-zinc-800 bg-zinc-950 p-6 space-y-5"
        >
          <div className="space-y-2">
            <Label className="text-zinc-300">URL base de n8n</Label>
            <Input
              value={form.n8n_base_url}
              onChange={(e) => setForm({ ...form, n8n_base_url: e.target.value })}
              placeholder="https://n8n.mi-dominio.com"
              className="bg-zinc-900 border-zinc-800 font-mono text-sm"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-zinc-300">
              API Key
              {settings?.n8n_api_key_set && (
                <span className="ml-2 text-[11px] font-mono text-emerald-400">
                  guardada: {settings.n8n_api_key_masked}
                </span>
              )}
            </Label>
            <Input
              type="password"
              value={form.n8n_api_key}
              onChange={(e) => setForm({ ...form, n8n_api_key: e.target.value })}
              placeholder={settings?.n8n_api_key_set ? "Dejar vacío para conservar" : "n8n_api_..."}
              className="bg-zinc-900 border-zinc-800 font-mono text-sm"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-zinc-300">Webhook URL</Label>
            <Input
              value={form.n8n_webhook_url}
              onChange={(e) => setForm({ ...form, n8n_webhook_url: e.target.value })}
              placeholder="https://n8n.mi-dominio.com/webhook/..."
              className="bg-zinc-900 border-zinc-800 font-mono text-sm"
            />
          </div>
          <div className="pt-2 flex justify-end">
            <Button
              type="submit"
              disabled={saving}
              className="bg-white text-black hover:bg-zinc-200"
            >
              {saving ? "Guardando…" : "Guardar"}
            </Button>
          </div>
        </form>

        <div className="space-y-4">
          <ComingSoon
            title="Ejecución de flujos"
            description="Cuando conectemos KRAI CONNECT con tu n8n, podrás disparar webhooks y ver ejecuciones desde este panel."
          />
        </div>
      </div>
    </div>
  );
}
